import React from 'react';
import styles from './EquifaxGenerate.module.scss';
import StyledButton from '../../../../components/StyledButton';
import TransactionIconAdmin from '../../../../svgs/TransactionIconAdmin';
import EquifaxReportModal from './EquifaxReportModal';

const EquifaxGenerateReport = ({
  refetch,
  modalDetail,
  setModalDetail,
}:
   {refetch: any;
    modalDetail: any;
    setModalDetail: any;
  }) => {
  const handleToggleModal = () => {
    setModalDetail({
      title: 'Generate Equifax File',
      subTitle: 'You are about to generate an Equifax file for the selected month',
      action: 'generateEquifaxFile',
      actionText: 'Generate File',
    });
  };
  return (
    <div className={styles?.wrapper}>
      <div className={styles?.wrapper__button_cover}>
        <StyledButton
          name="Generate Equifax Report"
          backgroundColor="#5941a9"
          color="#FFF"
          border="1px solid transparent"
          // width="125px"
          height="40px"
          fontSize="16px"
          disabled={false}
          borderRadius="8px"
          onClick={handleToggleModal}
          icon={<TransactionIconAdmin stroke="#ffffff" />}
        />
      </div>

      {modalDetail && (
      <EquifaxReportModal
        setModalDetail={setModalDetail}
        modalDetail={modalDetail || {}}
        isShow
        refetch={refetch}
      />
      )}
    </div>
  );
};

export default EquifaxGenerateReport;
